import { render, staticRenderFns } from "./FieldCustom.vue?vue&type=template&id=1b05220e&scoped=true&"
import script from "./FieldCustom.vue?vue&type=script&lang=ts&"
export * from "./FieldCustom.vue?vue&type=script&lang=ts&"
import style0 from "./FieldCustom.vue?vue&type=style&index=0&id=1b05220e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b05220e",
  null
  
)

export default component.exports